export default __webpack_public_path__ + "static/media/doubleClickService.89b711ea.svg";